
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/platnosci",
      function () {
        return require("private-next-pages/moje-konto/platnosci/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/platnosci"])
      });
    }
  